export enum SelectionType {
  Folder = 'folder',
  File = 'file',
  All = 'all'
}
